import React from 'react';

const TestUrls = () => (
  <div style={{ margin: '20px', lineHeight: '1.6' }}>
    <h1>Test URLs</h1>

    <h2>1</h2>
    <p>
    <a href="rewe://">rewe://</a>
    </p>
    <p>
    <a href="rewe://shop">rewe://shop</a>
    </p>
    <p>
    <a href="https://shop.rewe.de/">https://shop.rewe.de/</a>
    <br />
    <a href="https://rewe.de/shop/">https://rewe.de/shop/</a>
    </p>

    <p>
    <a href="https://shop.rewe.de/angebote">https://shop.rewe.de/angebote</a>
    <br />
    <a href="https://rewe.de/shop/angebote">https://rewe.de/shop/angebote</a>
    </p>
    <p>
    <a href="https://shop.rewe.de/c/milch">https://shop.rewe.de/c/milch</a>
    <br />
    <a href="https://rewe.de/shop/c/milch">https://rewe.de/shop/c/milch</a>
    </p>

    <h2>2</h2>
    <p>
    <a href="rewe://payback">rewe://payback</a>
    </p>
    <p>
    <a href="https://www.rewe.de/payback/">https://www.rewe.de/payback/</a>
    </p>
    <p>
    <a href="rewe://angebote">rewe://angebote</a>
    </p>
    <p>
    <a href="https://www.rewe.de/angebote">https://www.rewe.de/angebote</a>
    </p>
    <p>
    <a href="https://www.rewe.de/angebote/">https://www.rewe.de/angebote/</a>
    </p>
    <p>
    <a href="https://www.rewe.de/angebote/nationale-angebote/#5142873">https://www.rewe.de/angebote/nationale-angebote/#5142873</a>
    </p>
    <p>
    <a href="https://www.rewe.de/rezepte/">https://www.rewe.de/rezepte/</a>
    </p>
    <p>
    <a href="https://www.rewe.de/rezepte">https://www.rewe.de/rezepte</a>
    </p>
    <p>
    <a href="https://www.rewe.de/rezepte/lachsfilet-mit-hausfrauensosse/">https://www.rewe.de/rezepte/lachsfilet-mit-hausfrauensosse/</a>
    </p>
    <p>
    <a href="https://www.rewe.de/produkte/feldschloesschen-dunkles-winterbier-11x05-1/8384960/">https://www.rewe.de/produkte/feldschloesschen-dunkles-winterbier-11x05-1/8384960/</a>
    </p>
    <p>
    <a href="https://www.rewe.de/marktseite/koeln-dellbrueck/1940017/rewe-markt-dellbruecker-hauptstr-92-94/">https://www.rewe.de/marktseite/koeln-dellbrueck/1940017/rewe-markt-dellbruecker-hauptstr-92-94/</a>
    </p>

    <h2>3</h2>
    <p>
        <a href="rewe://web-content?title=Scheine%20f%C3%BCr%20Vereine&redirectUrl=https%3A%2F%2Fstage.p865c186.bloonix.cloud%3Fcode%3D1-2C9rg4KRDD1">rewe://web-content?title=Scheine für Vereine - Stage</a>
    </p>
    <p>
        <a href="rewe://web-content?title=Scheine%20f%C3%BCr%20Vereine&redirectUrl=https%3A%2F%2Fscheinefuervereine.rewe.de%3Fcode%3DV-28u22Dmemm1">rewe://web-content?title=Scheine für Vereine - Live</a>
    </p>

    <h2>4</h2>
    <p>
        <a href="https://rewe.de">https://rewe.de</a>
    </p>
    <p>
        <a href="https://rewe.de/">https://rewe.de/</a>
    </p>
    <p>
        <a href="https://rewe.de/angebote">https://rewe.de/angebote</a>
    </p>
    <p>
        <a href="https://rewe.de/angebote/">https://rewe.de/angebote/</a>
    </p>

    <h2>5</h2>
    <p>
        <a href="rewe://coupons">rewe://coupons</a>
    </p>
    <p>
        <a href="rewe://coupons/BAD_ID">rewe://coupons/BAD_ID</a>
    </p>
    <p>
        <a href="rewe://coupons/baf60e24-2392-45e6-9a86-ccd1830e5912">rewe://coupons/baf60e24-2392-45e6-9a86-ccd1830e5912</a>
    </p>
    <p>
        <a href="rewe://coupons/74661f84-deb7-47c2-b004-5706426d0173">rewe://coupons/74661f84-deb7-47c2-b004-5706426d0173</a>
    </p>
    <p>
        <a href="rewe://bonusguthaben">rewe://bonusguthaben</a>
    </p>
    <p>
        <a href="rewe://bonusbooster">rewe://bonusbooster</a>
    </p>
    <p>
        <a href="rewe://angebote/bonuskategorie">rewe://angebote/bonuskategorie</a>
    </p>
    <p>
        <a href="rewe://bonusteilnahmeflow">rewe://bonusteilnahmeflow</a>
    </p>
    <p>
        <a href="rewe://onescan">rewe://onescan</a>
    </p>
    <p>
        <a href="rewe://haushaltskonto">rewe://haushaltskonto</a>
    </p>
    <p>
        <a href="rewe://pewe">rewe://pewe</a>
    </p>

    <h2>6</h2>
    <p>
        <a href="https://shop.rewe.de/c/milch">https://shop.rewe.de/c/milch</a>
        <br />
        <a href="https://rewe.de/shop/c/milch">https://rewe.de/shop/c/milch</a>
    </p>
    <p>
        <a href="https://shop.rewe.de/c/nuesse">https://shop.rewe.de/c/nuesse</a>
        <br />
        <a href="https://rewe.de/shop/c/nuesse">https://rewe.de/shop/c/nuesse</a>
    </p>
    <p>
        <a href="https://shop.rewe.de/c/obst-gemuese">https://shop.rewe.de/c/obst-gemuese</a>
        <br />
        <a href="https://rewe.de/shop/c/obst-gemuese">https://rewe.de/shop/c/obst-gemuese</a>
    </p>
    <p>
        <a href="https://shop.rewe.de/c/regional">https://shop.rewe.de/c/regional</a>
        <br />
        <a href="https://rewe.de/shop/c/regional">https://rewe.de/shop/c/regional</a>
    </p>
    <p>
        <a href="https://shop.rewe.de/c/vegane-vielfalt">https://shop.rewe.de/c/vegane-vielfalt</a>
        <br />
        <a href="https://rewe.de/shop/c/vegane-vielfalt">https://rewe.de/shop/c/vegane-vielfalt</a>
    </p>
    
    <h2>7</h2>
    <p>
        <a href="rewe://coupons">rewe://coupons</a>
    </p>
    <p>
        <a href="rewe://vorteile">rewe://vorteile</a>
    </p>

    
    <h2>8</h2>
    <p>
        <a href="https://www.rewe.de/shop/angebote">https://www.rewe.de/shop/angebote</a>
        <br />
        <a href="https://rewe.de/shop/angebote">https://rewe.de/shop/angebote</a>
    </p>
    <p>
        <a href="https://www.rewe.de/shop/myproducts">https://www.rewe.de/shop/myproducts</a>
        <br />
        <a href="https://rewe.de/shop/myproducts">https://rewe.de/shop/myproducts</a>
    </p>
    <p>
        <a href="https://www.rewe.de/shop/mydata/orderhistory">https://www.rewe.de/shop/mydata/orderhistory</a>
        <br />
        <a href="https://rewe.de/shop/mydata/orderhistory">https://rewe.de/shop/mydata/orderhistory</a>
    </p>
    <p>
        <a href="https://www.rewe.de/shop/checkout/basket">https://www.rewe.de/shop/checkout/basket</a>
        <br />
        <a href="https://rewe.de/shop/checkout/basket">https://rewe.de/shop/checkout/basket</a>
    </p>
    <p>
        <a href="https://www.rewe.de/shop/mydata/meine-einkaeufe">https://www.rewe.de/shop/mydata/meine-einkaeufe</a>
        <br />
        <a href="https://rewe.de/shop/mydata/meine-einkaeufe">https://rewe.de/shop/mydata/meine-einkaeufe</a>
    </p>
    <p>
        <a href="https://www.rewe.de/shop/mydata/privacy">https://www.rewe.de/shop/mydata/privacy</a>
        <br />
        <a href="https://rewe.de/shop/mydata/privacy">https://rewe.de/shop/mydata/privacy</a>
    </p>

    <h2>9</h2>
    <p>
        <a href="rewe://shop/search?query=Schokolade&filters=attribute%3Dlowestprice&categorySlug=kaese-eier-molkerei">rewe://shop/search?query=Schokolade&filters=attribute%3Dlowestprice&categorySlug=kaese-eier-molkerei</a>
    </p>
    <p>
        <a href="rewe://shop/search?categorySlug=kaese-eier-molkerei&query=">rewe://shop/search?categorySlug=kaese-eier-molkerei&query=</a>
    </p>
    <p>
        <a href="rewe://shop/search?filters=attribute%3Dlowestprice&dangerousParameter=DO_EVIL">rewe://shop/search?filters=attribute%3Dlowestprice&dangerousParameter=DO_EVIL</a>
    </p>
    <p>
        <a href="rewe://shop/search/campaignKeyword:tiefpreis">rewe://shop/search/campaignKeyword:tiefpreis</a>
    </p>

        <h2>10</h2>
    <p>
        <a href="https://www.rewe.de/shop/opt-out/*">https://www.rewe.de/shop/opt-out/*</a>
    </p>
    <p>
        <a href="https://shop.rewe.de/opt-out/*">https://shop.rewe.de/opt-out/*</a>
    </p>
    <p>
        <a href="https://shop.rewe.de/api/consent/channels/opt-out/*">https://shop.rewe.de/api/consent/channels/opt-out/*</a>
    </p>
    <p>
        <a href="https://www.rewe.de/shop/api/consent/channels/opt-out/*">https://www.rewe.de/shop/api/consent/channels/opt-out/*</a>
    </p>

  </div>
);

export default TestUrls;
